const parseLocationsSelectData = locations =>
  locations.map(location => ({
    value: location._id,
    label: location.name,
  }));

export { parseLocationsSelectData };
